import { PHYSICAL_EXAM_SECTION_INITIAL_VALUES } from "./physical-exams";

export const LUNGS_FORM_INITIAL_VALUES = {
  sections: {
    lungs: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
  },
  notes: "",
};

export type PhysicalExamHeartSections = keyof typeof LUNGS_FORM_INITIAL_VALUES.sections;
